// src/app/core/tracking/tracking.providers.ts
import { inject, provideAppInitializer, type EnvironmentProviders } from '@angular/core';

import { AuthService } from '@/app/features/auth/services/auth.service';
import { CartTrackingService } from '@/app/core/tracking/cart-tracking.service';
import { EventQueueService } from '@/app/core/tracking/event-queue.service';
import { SessionContextService } from '@/app/core/tracking/session-context.service';

/**
 * Arranque del sistema de tracking (registrar en app.config.ts):
 * resuelve identidad (anonymous_id/session/UTMs), siembra el user_id si ya hay
 * sesión iniciada, activa la cola de envío y el espejo de carrito al backend.
 */
export function provideTracking(): EnvironmentProviders {
  return provideAppInitializer(() => {
    const sessionContext = inject(SessionContextService);
    const eventQueue = inject(EventQueueService);
    const cartTracking = inject(CartTrackingService);
    const auth = inject(AuthService);

    sessionContext.init(auth.userId);
    eventQueue.init();
    cartTracking.init();
  });
}
